var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0909 27.2727C19.5009 27.2727 21.4546 25.3191 21.4546 22.9091C21.4546 20.4991 19.5009 18.5455 17.0909 18.5455C14.681 18.5455 12.7273 20.4991 12.7273 22.9091C12.7273 25.3191 14.681 27.2727 17.0909 27.2727Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0909 36C24.32 36 30.1818 29.9389 30.1818 22.7113V9.81818L33.8182 13.4545L36 11.2727L28.7273 4L21.4545 11.2727L23.6364 13.4545L27.2727 9.81818V22.7113C27.2727 28.336 22.7156 33.0909 17.0909 33.0909C11.4662 33.0909 6.89019 28.5149 6.89019 22.8902C6.89019 20.0276 8.10473 17.2785 10.2211 15.3484L8.26182 13.2C6.91716 14.4345 5.84391 15.9351 5.11023 17.6065C4.37655 19.278 3.99847 21.0837 4 22.9091C4 26.381 5.37922 29.7107 7.83424 32.1658C10.2893 34.6208 13.619 36 17.0909 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployment);
export default __webpack_public_path__ + "static/media/deployment.b7dbd85163a9540735310e9daa971cdf.svg";
export { ForwardRef as ReactComponent };